export var ProgressBarEnum;
(function (ProgressBarEnum) {
  ProgressBarEnum["LinearBar"] = "LinearBar";
  ProgressBarEnum["Steps"] = "Steps";
})(ProgressBarEnum || (ProgressBarEnum = {}));
export var QuizActionType;
(function (QuizActionType) {
  QuizActionType["resultPage"] = "resultPage";
  QuizActionType["redirect"] = "redirect";
  QuizActionType["auth"] = "auth";
  QuizActionType["customEvent"] = "customEvent";
})(QuizActionType || (QuizActionType = {}));
export var QuizPageUrlRule;
(function (QuizPageUrlRule) {
  QuizPageUrlRule["exactly"] = "exactly";
  QuizPageUrlRule["contains"] = "contains";
  QuizPageUrlRule["regexp"] = "regexp";
})(QuizPageUrlRule || (QuizPageUrlRule = {}));